import { useConsent } from '@/lib/consent';
import { isPodscribeConfigured } from './client';

export const usePodscribeEnabled = (): boolean => {
  const { allowed } = useConsent();
  return allowed && isPodscribeConfigured();
};
